export default __webpack_public_path__ + "static/media/empty_left@2x.492b384c.png";